import { ColumnViewModel } from '../../shared/column-types';

export const CHEMICALS_GDA_EVIDENCE: ColumnViewModel = {
  columns: [
    'geneSymbol',
    'geneDescription',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiID',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'score',
    'sourceScore',
    'associationType',
    'ancestry_name',
    'disease_model_in_doc',
    'sex_in_doc',
    'source',
    'geneNcbiType',
    'sentenceHTML',
    'text',
    'chemsInSentence',
    'chemIDs',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'geneDSI',
    'geneDPI',
    'genepLI',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'geneEnsemblIDs',
    'geneProteinStrIDs',
    'geneProteinClassNames',
    'pathwayName',
    'pathwayID',
    'chemical_effect',
    'reference',
    'reference_type',
    'nct_title',
    'pmed_title',
    'nct_phase',
    'association',
    'citation_count',
    'icite_apt',
  ],
  defaultVisible: [
    'geneSymbol',
    'diseaseName',
    'score',
    'sourceScore',
    'associationType',
    'ancestry_name',
    'disease_model_in_doc',
    'sex_in_doc',
    'sentenceHTML',
    'chemsInSentence',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'reference',
    'reference_type',
    'nct_title',
    'pmed_title',
  ],
};